import { createSlice } from "@reduxjs/toolkit";

const filterSlice = createSlice({
  name: "filter",
  initialState: {
    acceptsReservations: null, // can be null (true or false), false, or true
    hasWineGlasses: null, // can be null (true or false), false, or true
    openNow: null,
    price: null, // null means any price (think infinity). otherwise, it should be a number between 0 to 50.
  },
  reducers: {
    setFilterAcceptsReservations: (state, action) => {
      state.acceptsReservations = action.payload;
    },
    setFilterHasWineGlasses: (state, action) => {
      state.hasWineGlasses = action.payload;
    },
    setFilterOpenNow: (state, action) => {
      state.openNow = action.payload;
    },
    setFilterPrice: (state, action) => {
      state.price = action.payload;
    },
  },
});

export default filterSlice;
